// extracted by mini-css-extract-plugin
module.exports = {"root":"StringFormatter_root__2_HBL"};